export default {
  read: {
    title: "Asesor",
    subtitle:
      "Solicita una consultoría con tu asesor digital para potenciar tu web."
  }
};
